import { render, staticRenderFns } from "./ArchivedResources.vue?vue&type=template&id=0460a31d&scoped=true&"
import script from "./ArchivedResources.vue?vue&type=script&lang=js&"
export * from "./ArchivedResources.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedResources.vue?vue&type=style&index=0&id=0460a31d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0460a31d",
  null
  
)

export default component.exports